/*
|--------------------------------------------------------------------------
| Views: Featured With Basic
|--------------------------------------------------------------------------
*/

/**
 * Featured With Basic
 * @namespace
 */
__gh__webApp.views.featuredWithBasic = {
	
	"callbacks": function(bucket){
		__gh__webApp.views.featuredWithBucket.callbacks({
			"bucket"		: bucket,
			"bucket2View"	: "basic"
		});
	},
	
	
	"defaultAds":{
		"noFeaturedSingleBucket":{
			"slot6": {},
			"slot4": {
				"view": "buckets/partials/ads/_billboard"
			}
		}
	},
	
	
	"getSubView": function(bucket){
		var	views					= __gh__webApp.views;
		
		return views.featuredWithBucket.getSubView({
			"bucket"		: bucket,
			"bucket2View"	: "basic"
		});

	}
};